import { throttle } from '@neux/ui-jquery/tool';
import { apiData } from './config.js';

let isMobile = false;
const mobileBreakPoint = 1159;
throttle(
	$(window).on('resize', function () {
		isMobile = $(window).innerWidth() <= mobileBreakPoint ? true : false;
	})
)
export { isMobile };

export function convertPageInfo(currentPageInfo, targetPageSize) {
	if (
		(targetPageSize && targetPageSize > 0) &&
		(currentPageInfo && currentPageInfo.page_size !== targetPageSize)
	) {
		const firstRecord = ((currentPageInfo.page - 1) * currentPageInfo.page_size) + 1;
		const targetPage = Math.ceil(firstRecord / targetPageSize);
		return {
			page: targetPage,
			page_size: targetPageSize
		};
	}
	return currentPageInfo;
}

export function addOpenWindowText(htmlContent) {
	if (!htmlContent) return '';
	const $content = $('<div>').html(htmlContent);
	$content.find('a[target="_blank"]').each(function () {
		const $this = $(this);
		if ($this.text().indexOf('(另開視窗)') === -1) {
			$this.append('(另開視窗)');
		}
	});
	return $content.html();
}

export function convertPageNumber() {

}

/**
 *
 * @export
 * @param {*} url api url
 * @param {*} type method
 * @param {*} doneFn success後執行function
 * @param {*} sendData 要送的資料
 * @return {*} 
 */
export function getData(url, type, doneFn, sendData) {
	return $.ajax({
		url: apiData[PROCESS.ENV][url],
		method: type,
		data: sendData ?? null,
		contentType: 'application/json; charset=utf-8',
		dataType: 'json'
	}).done((data) => {
		doneFn(data);
	}).fail(() => {
		console.error('API failed:' + apiData[PROCESS.ENV][url]);
	});
}

/**
 * 數字轉換中文數字
 * (簡便1-20)
 *
 * @export
 * @param {*} number 填入阿拉伯數字
 */
export function changeChtNumber(number) {
	const chtNumber = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];
	let outputText = '';
	outputText = number > 10 ? chtNumber[10] : '';
	outputText += chtNumber[number % 10];
	return outputText;
}

export function repairZero(val) {
	let outputText = val.toString();
	while (outputText.length <= 3) {
		outputText = '0' + outputText;
	}
	return outputText;
}